const value = {
    title: 'Сервис временно недоступен',
    message:
      'Мы уже знаем о проблеме и работаем над тем, чтобы все заработало как можно быстрее. Уточнить сроки и задать любые вопросы можно команде поддержки:',
  };

export default value;
